import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/dashboard/"
)({
  component: () => <Navigate to="/dashboard/overview" />,
})
